import { defineCopy } from "../intl";

import { PLAN_INQUIRY_COPY_EN_US } from "./en-us/plan-inquiry.copy";
import { PLAN_INQUIRY_COPY_ES_ES } from "./es-es/plan-inquiry.copy";

/**
 * Texto do plano sob consulta: o formulário público da vitrine
 * (`PlanInquiryModal` do web) e o pedido de proposta de dentro do produto
 * (`RequestProposalDialog`). Subiu do web quando o pedido chegou ao app e ao
 * desktop — o segundo consumidor que o comentário antigo esperava.
 */
export const PLAN_INQUIRY_COPY_PT_BR = {
  /** Título do estado `idle`/`sending`/`error` vem de `plan.name`, não daqui. */
  sentTitle: "Deu certo!",
  description:
    "Conta pra gente o tamanho da sua operação que a gente monta a proposta certa.",
  sentDescription: "Recebemos sua solicitação.",
  closeLabel: "Fechar",
  nameLabel: "Seu nome",
  emailLabel: "Seu e-mail",
  whatsappLabel: "WhatsApp com DDD",
  creatorsCountLabel: "Quantos creators (opcional)",
  messageLabel: "Quer contar mais alguma coisa? (opcional)",
  sentMessage:
    "A gente te chama no WhatsApp ou no e-mail que você deixou, pra combinar os próximos passos.",
  errorMessage: "Não foi possível enviar agora. Tente de novo em instantes.",
  submitLabel: "Enviar solicitação",
  submittingLabel: "Enviando...",
  /** Pedido de proposta de dentro do produto (`request-proposal-dialog.tsx` do web). */
  requestProposal: {
    description:
      "Conta pra gente o tamanho da sua operação que a gente monta a proposta certa.",
    needsPhoneDescription:
      "Só falta confirmar seu telefone — é por ele que a gente te avisa quando a proposta sair.",
    sentMessage:
      "A gente te chama no WhatsApp ou no e-mail da sua conta, pra combinar os próximos passos.",
    nameLabel: "Nome",
    emailLabel: "E-mail",
    whatsappLabel: "WhatsApp",
    empty: "—",
    creatorsCountLabel: "Quantos creators",
    optional: "(opcional)",
    creatorsSuffix: "creators",
    submit: "Pedir proposta",
  },
  /** Verificação do telefone dentro do pedido (`proposal-phone-verification-step.tsx`). */
  phoneVerification: {
    phoneLabel: "WhatsApp",
    phoneHint: "É por ele que a gente te avisa quando a proposta sair.",
    codeLabel: "Código recebido por SMS",
    confirm: "Confirmar e enviar pedido",
    resend: "Reenviar código",
    sendCode: "Enviar código por SMS",
  },
} as const;

export const PLAN_INQUIRY_COPY = defineCopy(PLAN_INQUIRY_COPY_PT_BR, {
  "en-US": PLAN_INQUIRY_COPY_EN_US,
  "es-ES": PLAN_INQUIRY_COPY_ES_ES,
});
